import { cn } from '#/shared/lib/utils'
import { CircleIcon, CircleUncheckedIcon } from '#/shared/ui/icons'

interface TaskStatusButtonProps {
  checked: boolean
  pending: boolean
  disabled?: boolean
  onClick: () => void
  label: string
}

const BASE_CLASS =
  'group/task-status flex size-5 shrink-0 transform-gpu cursor-pointer items-center justify-center rounded-full text-gray-500 outline-none transition-[transform,color] duration-150 ease-out focus-visible:focus-ring active:scale-90 disabled:cursor-not-allowed disabled:opacity-50'

function Spinner() {
  return (
    <span
      aria-hidden
      className="size-3.5 animate-spin rounded-full border-2 border-current border-t-transparent"
    />
  )
}

function CheckedIcons() {
  return (
    <>
      <CircleIcon className="size-4 text-primary group-hover/task-status:hidden" />
      <CircleUncheckedIcon className="hidden size-4 group-hover/task-status:block" />
    </>
  )
}

function UncheckedIcons() {
  return (
    <>
      <CircleUncheckedIcon className="size-4 group-hover/task-status:hidden" />
      <CircleIcon className="hidden size-4 text-primary group-hover/task-status:block" />
    </>
  )
}

export function TaskStatusButton({
  checked,
  pending,
  disabled = false,
  onClick,
  label,
}: TaskStatusButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      aria-pressed={checked}
      className={cn(
        BASE_CLASS,
        checked ? 'hover:text-gray-500' : 'hover:text-primary',
      )}
    >
      {pending ? <Spinner /> : checked ? <CheckedIcons /> : <UncheckedIcons />}
    </button>
  )
}
